import React, { useEffect, useState, useContext } from 'react';
import SubNavbar from './SubNavbar';
import { Link, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import './Navbar.css';
import { collectionContext } from '../../App';
import {
    getWindowDimensions, previousCart,
} from '../../driver';
import useAuth from "../hooks/useAuth";
import { useGetproductsQuery, useGetSearchDataQuery } from '../../features/api/apiSlice';
import { ProfileMenu } from './ProfileMenu';
import { SearchBar } from './SearchBar';
import { CartBadge } from './CartBadge';
import { MobileMenu } from './MobileMenu';
import { useDispatch } from 'react-redux';
import { cartData } from '../../features/cart/cartSlice'
import './spinner.css';


const Navbar = () => {

    const { value2, value4, value6 } = useContext(collectionContext);
    const { data: products } = useGetproductsQuery();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [refresh, setRefresh] = value2;
    const [, setSearchItem] = value4;
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [, setSearchLoading] = value6;
    const [searchProduct, setSearchProductName] = useState('cashew');
    const dispatch = useDispatch();

    const { user: { email, emailVerified } } = useAuth();
    const { data: getSearchData } = useGetSearchDataQuery({ searchValue: searchProduct, page: 1 })
    const navigate = useNavigate();
    const signout = () => {
        localStorage.removeItem("idToken");
        navigate('/login');
    }


    const signIn = () => {
        navigate('/login');
    }
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    useEffect(() => {
        dispatch(cartData(previousCart(products)));
        setRefresh(false);
    }, [setRefresh, products, refresh, dispatch])


    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };


    const [, setAnchorEl] = React.useState(null);

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const [searchByBtn, setSearchByBtn] = useState('');

    const handleSearch = (e) => {
        if (!e.target.value) return;
        if (e.key === 'Enter') {
            setSearchProductName(e.target.value)
            setSearchLoading(true);
            setSearchItem(getSearchData?.afterSplice);
            setSearchLoading(false);
            navigate(`/search-item/${e.target.value}`)
        }
    }


    const searchByButton = () => {
        if (!searchByBtn) return;
        async function fetchData() {
            setSearchLoading(true);
            setSearchItem(getSearchData?.afterSplice);
            setSearchLoading(false);
            navigate(`/search-item/${searchByBtn}`)
        }
        fetchData()
    }

    // Describe what to do render


    return (
        <div
            className={`navbar-block sticky`}>
            <div className="container nav-container">
                <div className="row">
                    {
                        windowDimensions.width < 576 ?
                            <MobileMenu
                                handleProfileMenuOpen={handleProfileMenuOpen}
                                handleDrawerToggle={handleDrawerToggle}
                                mobileOpen={mobileOpen}
                                email={email}
                                emailVerified={emailVerified}
                            />
                            :
                            <>
                                <div className="col-sm-2">
                                    <h3 style={{ cursor: 'pointer' }}>
                                        <Link to="/">
                                            Nuts
                                        </Link>
                                    </h3>
                                </div>
                                <SearchBar
                                    searchByBtn={searchByBtn}
                                    setSearchByBtn={setSearchByBtn}
                                    handleSearch={handleSearch}
                                    searchByButton={searchByButton}
                                />
                                <div className="col-sm-2 col-md-2 col-lg-2 col-xl-1 text-center ">
                                    <Box sx={{ flexGrow: 0 }}>
                                        <CartBadge />
                                        <ProfileMenu
                                            anchorElUser={anchorElUser} handleCloseUserMenu={handleCloseUserMenu}
                                            email={email}
                                            emailVerified={emailVerified}
                                            signout={signout}
                                            signIn={signIn}
                                            handleOpenUserMenu={handleOpenUserMenu}
                                        />
                                    </Box>
                                </div>
                            </>
                    }

                </div>
            </div>
            {
                windowDimensions.width > 575 && <SubNavbar />
            }

        </div>
    );
};

export default Navbar;